// Client Config File
//
//
const isDevelopment = process.env.NODE_ENV !== 'production'

export default {
  clientUrl: isDevelopment ? 'http://localhost:3000/' : '/',
  serverUrl: isDevelopment ? 'http://localhost:8000/' : '/',
}
